// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DMxva","col":"styles_col__vg1lf"};